import { render, staticRenderFns } from "./OffCanvasTuote.vue?vue&type=template&id=619d7070&scoped=true&"
import script from "./OffCanvasTuote.vue?vue&type=script&lang=js&"
export * from "./OffCanvasTuote.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvasTuote.vue?vue&type=style&index=0&id=619d7070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d7070",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619d7070')) {
      api.createRecord('619d7070', component.options)
    } else {
      api.reload('619d7070', component.options)
    }
    module.hot.accept("./OffCanvasTuote.vue?vue&type=template&id=619d7070&scoped=true&", function () {
      api.rerender('619d7070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasTuote.vue"
export default component.exports